import { render, staticRenderFns } from "./TermsAndConditionsText.vue?vue&type=template&id=4f8586a8&scoped=true"
import script from "./TermsAndConditionsText.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8586a8",
  null
  
)

export default component.exports